module.exports = "https://d2e8d75hhtblx4.cloudfront.net/_next/static/public/static/images/favicon/apple-touch-icon-144x144834090d748b62b27192bd9c87eb90640.png";